import config from '../../../../config';

import { RECEIVE_PRODUCT_TEMPLATES } from '../../../ActionsConst';

import { getProductSizes } from '../../../services/product-type/ProductTypeService';
import apiRequest from '../../../../stores/ApiService';

const templatePageSize = config.page.productTemplates;

export const receiveTemplates = (templates) => ({
  type: RECEIVE_PRODUCT_TEMPLATES,
  templates,
});

const buildBaseTemplatesURI = (apiUrl, productTypeId) => {
  let productSizeParam = '';

  const productTypeSizes = getProductSizes(productTypeId);
  productTypeSizes.forEach((productSize, index) => {
    const separator = index === 0 ? '' : ',';
    productSizeParam += `${separator}${encodeURIComponent(productSize.id)}`;
  });

  return `${apiUrl}/templates?productSize=${productSizeParam}&sort=nameAsc&size=${templatePageSize}`;
};

const createApiRequestForPage = (baseUrl, page) =>
  apiRequest({
    method: 'GET',
    url: `${baseUrl}&from=${page * templatePageSize}`,
  });

const appendUniqueTemplates = (prevTemplates, newTemplates) => {
  // Avoid adding duplicates in case some product gets added etc during the requests
  const existingIds = prevTemplates.map((template) => template.id);
  const templatesToAdd = newTemplates.filter((newTemplate) => existingIds.indexOf(newTemplate.id) === -1);
  return prevTemplates.concat(templatesToAdd);
};

const combinePageTemplates = (firstPageTemplates, nextPagesResponses) => {
  // Ensure only 1 of each template is added to the result even when two page requests return the same item
  return nextPagesResponses.reduce((prevTemplates, jsonResponse) => {
    return appendUniqueTemplates(prevTemplates, jsonResponse.items);
  }, firstPageTemplates);
};

const getCombinedPagesResponse = (firstResponse, baseUrl) => {
  const nextPagesCount = Math.ceil(firstResponse.total / templatePageSize) - 1;
  const nextPagePromises = [];
  for (let page = 1; page <= nextPagesCount; page += 1) {
    nextPagePromises.push(createApiRequestForPage(baseUrl, page));
  }
  return (
    Promise.all(nextPagePromises)
      .then((nextPageResponses) => Promise.all(nextPageResponses.map((promise) => promise.json())))
      .then((nextPageResponsesJSON) => combinePageTemplates(firstResponse.items, nextPageResponsesJSON))
      // When one of the additional pages fails, return the first page results
      .catch(() => firstResponse.items)
  );
};

export const requestProductTemplates = (productTypeId, apiUrl) => {
  return (dispatch) => {
    const baseTemplateUrl = buildBaseTemplatesURI(apiUrl, productTypeId);

    return createApiRequestForPage(baseTemplateUrl, 0)
      .then((firstPageResponse) => {
        if (firstPageResponse.isRedirected) {
          return [];
        }
        return firstPageResponse.json().then((firstPageJSON) => {
          if (firstPageJSON.total <= templatePageSize) {
            return firstPageJSON.items;
          }
          return getCombinedPagesResponse(firstPageJSON, baseTemplateUrl);
        });
      })
      .then((templates) => dispatch(receiveTemplates(templates)));
  };
};
